import * as React from 'react';

import { UitkCheckbox } from 'uitk-react-switch';

import { trackAnalytics } from 'utility';
import { useStores } from 'utility/hooks';
import { FlightsSearchFormMoreFiltersOptionItem, FlightsSearchFormMoreFiltersOption } from 'types/search/wizard';

interface BaseMoreFilterProps {
  item: FlightsSearchFormMoreFiltersOptionItem;
  advancedFilterType: string;
  itemIndex: number;
  searchOption: FlightsSearchFormMoreFiltersOption;
}

export const BaseMoreFilter = ({ advancedFilterType, item, itemIndex, searchOption }: BaseMoreFilterProps) => {
  const { analytics } = useStores();

  const updateAdvancedFilters = () => {
    searchOption.items.forEach((item: FlightsSearchFormMoreFiltersOptionItem) => {
      if (item.advancedFilterType === advancedFilterType) {
        item.selected = !item.selected;
        const filterAnalytics = item.selected
          ? item.advancedFilterSelectedAnalytics
          : item.advancedFilterRemoveAnalytics;
        trackAnalytics(filterAnalytics, analytics);
      }
    });
  };

  return (
    <UitkCheckbox
      label={item.label}
      id={`search-more-filters-option-${itemIndex}`}
      checked={item.selected}
      onChange={updateAdvancedFilters}
    />
  );
};
